module.exports = __webpack_public_path__ + "images/mmm-07-desktop.png";